<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="user"
      :class="{
        opened: opened.indexOf('userDetail') >= 0,
        'last-active': opened.indexOf('userDetail') === opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="closeBox('userDetail')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("detailUzivatele") }} {{ user.email }}</h2>
      </div>
      <div class="side-box__content">
        <div class="my-4">
          <a :class="{ opened: infoOpened }" class="atom-form-group__toggler" @click="infoOpened = !infoOpened">
            {{ $t("informaceOUzivateli") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: infoOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label text gray-text">
                {{ $t("prilasovaciJmeno") }}
              </span>
              <span class="side-box__content__value ml-3">
                {{ user.userId }}
              </span>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label text gray-text">
                {{ $t("krestniJmeno") }}
              </span>
              <span class="side-box__content__value ml-3">
                {{ user.firstName }}
              </span>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label text gray-text">
                {{ $t("prijmeni") }}
              </span>
              <span class="side-box__content__value ml-3">
                {{ user.lastName }}
              </span>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label text gray-text">
                {{ $t("telefon") }}
              </span>
              <span class="side-box__content__value ml-3">
                {{ $filters.phone(user.phone, "CZ") }}
              </span>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label text gray-text">
                {{ $t("email") }}
              </span>
              <span class="side-box__content__value ml-3">
                {{ user.email }}
                {{ usersProjects.length }}
              </span>
            </div>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: projectsOpened }"
            class="atom-form-group__toggler"
            @click="projectsOpened = !projectsOpened"
          >
            {{ $t("projektyNazev") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div v-if="usersProjects.length > 0" :class="{ opened: projectsOpened }" class="atom-form-group__content">
            <div
              v-if="usersProjects.length > 0 && usersProjects[0] !== 'all'"
              class="mesages__timestamps side-box__row"
            >
              <div class="mt-3">
                <div class="d-flex">
                  <span class="messages__timestamps__col endpoits gray-text">
                    {{ $t("projectId") }}
                  </span>
                  <span class="messages__timestamps__col gray-text">
                    {{ $t("nazevUctu") }}
                  </span>
                </div>
                <div
                  v-for="project in usersProjects"
                  :key="project.counterId"
                  class="d-flex messages__timestamps__item"
                >
                  <span class="messages__timestamps__col endpoits">
                    {{ $t(project.projectId) }}
                  </span>
                  <span class="messages__timestamps__col">
                    {{ project.projectName }}
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="usersProjects.length > 0 && usersProjects[0] === 'all'"
              class="mesages__timestamps side-box__row"
            >
              <div class="mt-3">
                <div class="d-flex messages__timestamps__item">
                  <span class="messages__timestamps__col endpoits">
                    {{ $t("Přístup ke všem projektům") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"

export default {
  props: {
    user: Object,
    opened: Array
  },
  emits: ["closeBox", "openBox"],
  setup() {
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()

    return { customerStore, projectStore }
  },
  data() {
    return {
      projectsOpened: true,
      infoOpened: true,
      usersProjects: []
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer ?? { customerId: this.$route.params.customerId }
    },
    projects() {
      return this.projectStore.projectList
    }
  },
  watch: {
    storedCustomer() {
      this.loadProjects()
    },
    projects() {
      this.loadProjects()
    }
  },
  mounted() {
    if (this.storedCustomer) {
      this.loadProjects()
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "userDetail") {
        this.$emit("closeBox", box)
      } else {
        this.$emit("closeBox", box)
      }
    },
    loadProjects() {
      this.setUsersProjects()
    },
    setUsersProjects() {
      this.user.projects.forEach((userproject) => {
        this.projects.forEach((p) => {
          if (p.customerId === this.storedCustomer.customerId) {
            if (p.projectId === userproject) {
              this.usersProjects.push(p)
            }
          }
        })
      })

      // customerAdmin has all projects
      if (
        this.user.privileges.some(
          ({ privilege, customerId }) => privilege === "CustomerAdmin" && customerId === this.storedCustomer.customerId
        )
      ) {
        this.usersProjects = []
        this.usersProjects.push("all")
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
